export const articles = 'articles';
export const article = 'article';
export const articleCategory = 'articleCategory';
export const articleYear = 'articleYear';
export const availableJobs = 'availableJobs';
export const companyDebitForm = 'companyDebitForm';
export const contact = 'contact';
export const contentSite = 'contentSite';
export const customerOpinions = 'customerOpinions';
export const damageReport = 'damageReport';
export const deliverytime = 'deliverytime';
export const events = 'events';
export const event = 'event';
export const frontpage = 'frontpage';
export const generalPostInfo = 'generalPostInfo';
export const homeDelivery = 'homeDelivery';
export const inquiry = 'inquiry';
export const menuGroup = 'menuGroup';
export const menuSubGroup = 'menuSubGroup';
export const newsletterSubscription = 'newsletterSubscription';
export const myShipments = 'myShipments';
export const myShipmentsRegistration = 'myShipmentsRegistration';
export const myShipmentsForgotPassword = 'myShipmentsForgotPassword';
export const openingHours = 'openingHours';
export const postboxDelivery = 'postboxDelivery';
export const postboxPromo = 'postBoxPromo';
export const priceListGroup = 'priceListGroup';
export const registerShipment = 'registerShipment';
export const registerShipmentCalculator = 'registerShipmentCalculator';
export const search = 'search';
export const sendReceipt = 'sendReceipt';
export const sendReceiptMultistep = 'sendReceiptMultistep';
export const shipmentCalculator = 'shipmentCalculator';
export const styleguide = 'styleguide';
export const trackShipment = 'findShipment';
export const myShipmentsSocialIdVerification = 'myShipmentsSocialIdVerification';
export const myShipmentsEmailVerification = 'myShipmentsEmailVerification';
export const myShipmentsResetPassword = 'myShipmentsResetPassword';
export const myShipmentsSettings = 'myShipmentsSettings';
export const myShipmentsShipment = 'myShipmentsShipment';
export const myShipmentRecipients = 'myShipmentsRecipients';
export const myShipmentsRefund = 'myShipmentsRefund';
export const myShipmentsRegisterShipment = 'myShipmentsRegisterShipment';
export const postboxFull = 'postboxFull';
